import { render } from "./public-header.vue?vue&type=template&id=2ac45424"
const script = {}

import exportComponent from "C:\\Codeframe\\Dev\\cdn\\express-documents\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__